import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import "./tablePresupuestoGasto.css";
import agregarCategoria from "../../img/tabla/agregarCategoria.svg";

import { TitlesRow } from "./TitlesRow";
import { ItemsRow } from "./ItemsRow";
import { useCallback } from "react";

const TablaPptos = ({
  addTitle,
  listaTiposDocumentos,
  handleOpenListCompras,
  isEditMode,
}) => {
  const { items: detailPttos, cant_items } = useSelector(
    (state) => state.pptoGasto.detail,
  );

  const checkCant = useCallback(() => {
    if (cant_items > 20) {
      document.getElementById("contraer-items").click();
    }
  }, [cant_items]);

  useEffect(() => {
    checkCant();
  }, [cant_items, checkCant]);

  return (
    <TableContainer component={Paper} className="p-border-table">
      <Table size="small" aria-label="a dense table">
        <TableHead>
          {/* 1ra fila */}
          <TableRow key="888888TableRow">
            <TableCell colSpan={8} className="p-border-separate">
              <div className="d-flex align-items-center justify-content-start">
                {/* <div className="tabla-punto-cliente"></div> */}
                <span className="ms-2 p-text-header p-fs-12px">
                  ITEMS DEL PRESUPUESTO
                </span>
              </div>
            </TableCell>
            {/*  <TableCell colSpan={3} className="p-border-separate">
              <div className="d-flex align-items-center justify-content-center">
                <div className="tabla-punto-ppto"></div>
                <span className="ms-2 p-text-header p-fs-12px">ACTUAL</span>
              </div>
            </TableCell>
            <TableCell colSpan={2}>
              <div className="d-flex align-items-center justify-content-center">
                <div className="tabla-punto-rentabilidad"></div>
                <span className="ms-2 d-flex align-items-center">
                  <span className="p-text-header p-fs-12px">PENDIENTE</span>
                </span>
              </div>
            </TableCell>
            <TableCell></TableCell> */}
          </TableRow>

          {/* 2da fila */}
          <TableRow key="999999TableRow" className="p-table-text-title">
            {isEditMode && (
              <TableCell className="p-border-separate">
                <div className="justify-content-start">
                  <img
                    className="tabla-icons-actions"
                    src={agregarCategoria}
                    alt="agregar título"
                    title="Agregar nuevo título"
                    onClick={addTitle}
                  />
                </div>
              </TableCell>
            )}
            <TableCell align="center" className="sticky left-0 bg-white">
              Ítems
            </TableCell>
            <TableCell align="center">Cantidad</TableCell>
            <TableCell align="center">Meses</TableCell>

            {isEditMode && (
              <>
                <TableCell align="right" className="min-w-32 text-end">
                  Unitario
                </TableCell>
                <TableCell align="right" className="p-border-separate min-w-32">
                  Monto Neto
                </TableCell>
                {/* ppto + impuesto  */}
                <TableCell align="center">Impuesto</TableCell>
              </>
            )}

            <TableCell align="center" className="p-border-separate">
              {isEditMode ? "Total" : "Presupuestado"}
            </TableCell>

            {/* gasto real  */}

            {/*  {isEditMode && (
              <>
                <TableCell align="right">Gasto Neto</TableCell>
                <TableCell align="right">Impuesto</TableCell>
              </>
            )} */}

            {/*  <TableCell align="right">
              {isEditMode ? "Gasto Total" : "Gastado"}
            </TableCell> */}

            {/* por gastar */}
            {/* <TableCell align="right">Por Gastar</TableCell>
            <TableCell align="center">Seleccionar</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {detailPttos.map((title) => (
            <>
              <TitlesRow key={title.id} title={title} isEditMode={isEditMode} />
              {title.items.map((item) => (
                <ItemsRow
                  key={item.id}
                  item={item}
                  listaTiposDocumentos={listaTiposDocumentos}
                  handleOpenListCompras={handleOpenListCompras}
                  isEditMode={isEditMode}
                />
              ))}
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TablaPptos;
